import React, { useContext, useState } from 'react';
import PageBanner from '../Usables/PageBanner';
import { basePath, getGreeting, parseQueryString} from '../Constants/constant';
import axios from 'axios';
import InputField, { FileInput } from '../Usables/InputField';
import BasicButton from '../Usables/Buttons';
import Swal from 'sweetalert2';
import Footer from '../Usables/Footer';
import { AppContext } from '../ContextApi/ContextApi';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaCheckCircle } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import LazyImage from '../Usables/LazyImage';
import Loader from '../Usables/Loader';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const UploadResume = () => {
    const query = new URLSearchParams(useLocation().search);
    const encryptedData = decodeURIComponent(query.get("data"));
    const {apiHeaderJSON, apiHeaderFile} = useContext(AppContext);
    const [data, setData] = useState("");
    const [candidateId, setCanidateId] = useState(null);
    const [formData, setFormData] = useState("");
    const [screen, setScreen] = useState(false);
    const [loading, setLoading] = useState(true);

    const getList = async (candidateId) => {
        try {
           
            const response = await axios.get(`${basePath}/GetCandiateInfo`, { params: {candidate_id:candidateId}});
            // console.log("getcandidatedata ==>>", response);
            if(response?.status === 200){
                setScreen(response?.data?.link_status);
                setData(response?.data?.data);
            }
            else{
                setScreen(false);
              
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setScreen(false);
            console.log(error);
        }
    }
    const getDecryptdata = async () => {
        try {
            const options = {
                headers: {...apiHeaderJSON}
            }
            const response = await axios.post(`${basePath}/decryptDataFromFrontend`, {encryptedData}, options);
            console.log("getDashboardData==>>", response);
            if(response?.status === 200){           
                const temp= parseQueryString(response?.data?.decryptedData);
                setCanidateId(temp?.process_id);
                getList(temp?.process_id);
            }
            else{
                setScreen(false);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            setScreen(false);
            console.log(error);
        }
    }

    const handleSubmit = () => {
        try {
            Swal.fire({
            title: 'Are you sure?',
            text: `You want to save information!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Change!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30',
            cancelButtonColor: '#F44336',
            allowOutsideClick: false,
            }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setLoading(2);
                    const options = {
                        headers: { ...apiHeaderFile },
                    };
                    const data = {
                        candidate_id: candidateId,
                        file: formData?.candidate_resume,
                        remarks: formData?.candidate_remarks,
                    };

                    const response = await axios.post(`${basePath}/updateResume`, data, options);

                    if (response.status === 200) {
                        toast.success(response.data?.message || "Successfully updated resume.");
                        getList(candidateId);
                    } else {
                        toast.error(response.data?.message || "Unexpected response.");
                    }

                } catch (error) {
                    if (error.response) {
                        toast.error(error.response.data?.message || "Something went wrong.");
                    } else {
                        toast.error(error.message || "Something went wrong.");
                    }
                } finally {
                    setLoading(false);
                }
            }
            });
        } catch (error) {
            toast.error(error.message || "Something went wrong.");
            setLoading(false);
        }
    };

    const handleChange = (event)=> {
        const {name, value} = event.target;
        setFormData({...formData, [name]: value});
    }

    useEffect(()=>{
        if(encryptedData){
            getDecryptdata();
        }
    },[encryptedData]);

    return (
        <section className='lightBabyGreen relative w-full min-h-screen' >
            {!loading ? 
                <>
                    {screen === 1 ? 
                        <div className=' flex flex-col flex-grow-1 justify-between items-start p-5 w-full min-h-[94dvh]'>
                            <div className=' m-auto lg:w-3/4 w-full'>
                                <div className='flex-1 w-full'>
                                {/* PageBanner => used to show page banner info */}
                                    <PageBanner pageName={`Hii, ${data[0]?.allCV?.cand_name || ""}`} pageTitle={`${getGreeting()}!`} src='/img/homeImg.png' alt="home" />
                                    <div className=' bg-white mt-4 p-3 rounded-lg grayBlurShadow'>
                                        <div className='grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-3'>
                                            <InputField name="name" type="text" label="Name:"
                                            disabled={true}
                                            value={data[0]?.allCV?.cand_name || '' }
                                            />
                                            <InputField name="email" type="text" label="Email:"
                                            disabled={true}
                                            value={data[0]?.allCV?.email || ''}
                                            />
                                            <InputField name="mobile" type="text" label="Mobile:"
                                            disabled={true}
                                            value={data[0]?.allCV?.phone || ''}
                                            />
                                            <FileInput
                                            name="candidate_resume"
                                            accept=".pdf"
                                            label="Update Resume*:"
                                            placeholder="Upload"
                                            disabled={loading}
                                            value={formData?.candidate_resume}
                                            onSelect={handleChange} />
                                        </div>
                                        <h4 htmlFor="candidate_remarks" className='mb-1 mt-4 text-left'>Remark:</h4>
                                        <textarea name="candidate_remarks" id="candidate_remarks" rows="5"
                                        className='w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                                        disabled={loading} placeholder="Enter Remark or any other information..." onChange={handleChange}
                                        >{formData?.candidate_remarks}</textarea>
                                        <div className=" text-left">
                                        <BasicButton onClick={handleSubmit} buttonName='Submit' className='darkPurple text-nowrap mt-4 px-6' shadow={true}
                                        disabled={loading || !formData?.candidate_resume || !formData?.candidate_remarks} 
                                        loading={loading === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <Footer/>
                        </div> :
                    screen === 2 ?
                        <div className="py-5 flex justify-center items-center h-screen px-5">
                        <div className="overflow-hidden p-0">
                            <div className="flex justify-center">
                                <div className="text-center">
                                    <div className=" flex flex-col gap-6 mt-3">
                                        <h3 className="flex items-center justify-center gap-3 text-5xl font-bold text-green-500">
                                            <FaCheckCircle className=' text-green-500 text-5xl' />
                                            Thank You!
                                        </h3>
                                        <p className="text-gray-500 font-semibold mb-4">
                                            Your response has been saved successfully. We’ll reach out if any opportunities match your profile.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div> :
                        <div className="py-5 flex justify-center items-center h-screen px-5">
                            <div className="flex justify-center">
                                <div className=" flex flex-col justify-center items-center mt-3 pb-8">
                                    <LazyImage className=" md:w-[35%] w-3/4" src="/img/not-found.png" />
                                    <p className="flex md:items-center items-start justify-center md:text-4xl sm:text-3xl text-xl font-semibold">
                                        <IoClose className='text-red-600 md:text-6xl text-3xl ' /> The link you followed has broken.
                                    </p>
                                </div>
                            </div>
                        </div>}
                </> :
                <div className=' bg-white flex justify-center items-center h-[100dvh] '>
                    <div className=' flex justify-center items-center w-fit m-auto h-full '>
                        <Loader/>
                    </div>
                </div>
            }
        </section>
    );
}

export default UploadResume;
